var map = {
	"./dress-code.jpg": 6749,
	"./home-eccellenza.jpg": 4020,
	"./home-header.jpg": 6546,
	"./home-kafes.jpg": 6905,
	"./home-mulini-def.jpg": 4071,
	"./home-mulini.jpg": 7557,
	"./home-piccola-venezia.jpg": 9283,
	"./home-sirtaki.jpg": 9036,
	"./home-superstizioni-greche.jpg": 2111,
	"./home-uccello-buon-augurio.jpg": 8732,
	"./hotel-myconian.jpg": 2198,
	"./programma-giorno-1.jpg": 1071,
	"./programma-giorno-2.jpg": 5280,
	"./programma-giorno-3.jpg": 1040
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1810;